import React from "react";

import { IgPaper } from "@intelligems/ig-theme";
import { WidgetType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ColorAndStyle } from "@src/components/ColorAndStyle/ColorAndStyle";
import { UserInterfacePreview } from "@src/features/personalizations/components/offerModifications/widgets/UserInterfacePreview";
import { useUserInterfaceConfigForOffer } from "@src/store/slices/userInterfaces/selectors";

interface OfferComponentSettingsPageWrapperProps {
  variationId: string;
  widgetType: WidgetType;
  hasQuantityButtons: boolean;
  hasProgressbar: boolean;
  hasMessageBox: boolean;
  offerProducts?: any;
  children?: React.ReactNode;
  customPreview?: React.ReactNode;
  widgetId?: string;
}

export const OfferComponentSettingsPageWrapper = ({
  variationId,
  widgetType,
  hasQuantityButtons,
  hasProgressbar,
  hasMessageBox,
  offerProducts,
  children,
  customPreview,
  widgetId,
}: OfferComponentSettingsPageWrapperProps) => {
  const config = useUserInterfaceConfigForOffer(variationId);

  return (
    <Grid container direction={"column"} width={"1250px"} mb={8}>
      <Grid container item direction={"row"} wrap={"nowrap"} gap={6}>
        <Grid container item xs={7} direction={"column"} spacing={4}>
          {children && <Grid item>{children}</Grid>}
          <Grid item>
            <ColorAndStyle
              variationId={variationId}
              widgetType={widgetType}
              widgetId={widgetId}
            />
          </Grid>
        </Grid>

        <Grid container item xs={5}>
          <Grid
            item
            width={"100%"}
            sx={{
              position: "sticky",
              top: 0,
              alignSelf: "flex-start",
            }}
          >
            <IgPaper sx={{ padding: 0 }}>
              {customPreview || (
                <UserInterfacePreview
                  offerProducts={offerProducts ?? []}
                  variationId={variationId}
                  config={config}
                  hasQuantityButtons={hasQuantityButtons}
                  hasProgressbar={hasProgressbar}
                  hasMessageBox={hasMessageBox}
                  renderLocation={"settings"}
                />
              )}
            </IgPaper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
